import { useEffect, useRef } from "react";

export const usePreviousValue = <T>(value: T, valuesToIgnore: T[] = []): T => {
  const ref = useRef<T>();
  useEffect(() => {
    if (!valuesToIgnore.includes(value)) {
      ref.current = value;
    }
  }, [value, valuesToIgnore]);

  return ref.current!;
};
